import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextosSobreNosotros = ({ lang, sobrenosotros }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";


    return (
        <>
            <section class="u-clearfix u-image u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-valign-middle-xs u-section-1" id="sec-5458" data-image-width="1680" data-image-height="1024">
                <h1 class="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-white u-title u-text-1">{t("Sobre Nosotros").toUpperCase()}</h1>
            </section>
            <section class="u-clearfix u-section-2" id="block-10">
                <div class="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                    {ReactHtmlParser(sobrenosotros.ladesc)}
                </div>
            </section>
        </>
    );
}


export default TextosSobreNosotros;
